import { render, staticRenderFns } from "./LivingOptionsPackages.vue?vue&type=template&id=60e52ed6"
import script from "./LivingOptionsPackages.vue?vue&type=script&lang=js"
export * from "./LivingOptionsPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports